module.exports = __webpack_public_path__ + "img/637.3e0ff427.jpg";